function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { StickyContainer } from 'react-sticky-modified';
import { instantScrollTop } from 'swag-client-common/utils/tricks';
import { HEADER_PRODUCT_LISTING } from 'swag-client-common/utils/constants';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { variables } from 'swag-client-common/styles/css-variables-helper';
import Page from '../../../page';
import { Filters } from '../../../popups/filters-popup';
import TechstarsLogo from '../../../ui/techstars-logo';
import SpringLogo from '../../../ui/spring-logo';
import { MobileProductListingActiveFiltersRow } from '../../../page/components/header/components/filters-row-panel';
import FilterControllers from '../filter-controllers';
import InfiniteProducts from './components/infinite-products';
import { ProductsSorting } from './components/products-sorting';
import { CategoryDescription } from './components/category-description';
import HiddenPagination from './components/hidden-pagination';
import FilterItem from './components/filter-item';
import classes from './product-listing.scss';
import { PostalPanel } from './components/postal-panel';
import { anchorOrigin, targetOrigin } from './product-listing-other';
const getHeaderParams = route => {
  switch (route) {
    case APP_ROUTES.TECHSTARS:
      return {
        headerLogoContent: /*#__PURE__*/React.createElement(TechstarsLogo, null),
        headerLink: APP_ROUTES.TECHSTARS
      };
    case APP_ROUTES.SPRING:
      return {
        headerLogoContent: /*#__PURE__*/React.createElement(SpringLogo, null),
        headerLink: APP_ROUTES.SPRING
      };
    default:
      return undefined;
  }
};
export class ProductListingComponent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      filtersIsOpen: false,
      sortingIsOpen: false,
      filterSelected: 'newest',
      anchorEl: undefined,
      items: []
    });
    _defineProperty(this, "openSorting", e => {
      e.preventDefault();
      this.setState({
        sortingIsOpen: true,
        anchorEl: e.currentTarget
      });
    });
    _defineProperty(this, "sortProducts", (_e, v) => {
      this.props.sortProducts({
        sorting: v
      });
      this.setState({
        sortingIsOpen: false
      });
    });
    _defineProperty(this, "closeSorting", () => {
      this.setState({
        sortingIsOpen: false
      });
    });
    _defineProperty(this, "openCategories", () => {
      this.props.changeIsShownMobMenuState(true);
    });
  }
  componentDidMount() {
    instantScrollTop();
  }
  render() {
    var _currentParentCategor;
    const {
      productListing: {
        isCategoriesListFetched,
        currentCategoryName,
        page,
        lastPage,
        isProductsListFetched,
        sorting,
        isAllProductsListPage,
        isActiveFilterBlockShown,
        withPurpleWave,
        shouldShowBackLink
      },
      categories,
      colorFamily,
      currentCategory,
      currentParentCategory,
      getProducts,
      headerTitle,
      isEmptyProductList,
      isFilterPopupOpen,
      isLoading,
      minQuantity,
      onCloseFilterPanel,
      onOpenFilterPanel,
      pricing,
      productAttributes,
      productionTime,
      shouldShowFiltersPanel,
      withAnimation,
      isCuratedBrandStore,
      categoriesAndFiltersAreHiddenForCBS
    } = this.props;
    const hasSubcategories = currentParentCategory === null || currentParentCategory === void 0 ? void 0 : (_currentParentCategor = currentParentCategory.subcategories) === null || _currentParentCategor === void 0 ? void 0 : _currentParentCategor.length;
    const {
      sortingIsOpen,
      anchorEl
    } = this.state;
    const currentRoute = location.pathname.split('/')[1];
    const headerParams = getHeaderParams(currentRoute);
    const isViolet = true;
    const isLogoCategory = currentParentCategory.isLogoCategory;
    return /*#__PURE__*/React.createElement(StickyContainer, null, /*#__PURE__*/React.createElement(Page, _extends({
      header: HEADER_PRODUCT_LISTING,
      headerIsSticky: true,
      withPurpleWave: withPurpleWave,
      isBoxButtonShown: true,
      headerIsViolet: isViolet,
      regularBrowseProductsLink: true,
      isAdviceBannerShow: page === lastPage && isProductsListFetched,
      showCategories: withAnimation
    }, headerParams), isCategoriesListFetched && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.categories, {
        [classes.emptyProductList]: isEmptyProductList,
        [classes.minHeightWhileLoading]: isLoading
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.separatorStyle, {
        [classes.logoSeparator]: isLogoCategory,
        [classes.thinSeparator]: isFilterPopupOpen,
        [classes.withoutSubcategories]: !hasSubcategories,
        [classes.activeFiltersSeparator]: shouldShowFiltersPanel,
        [classes.separatorStyleWithAnimation]: withAnimation
      })
    }), /*#__PURE__*/React.createElement(FilterControllers, {
      isFilterPopupOpen: isFilterPopupOpen,
      onOpenCategories: this.openCategories,
      onOpenFilterPanel: onOpenFilterPanel,
      onOpenSorting: this.openSorting,
      hideCategories: categoriesAndFiltersAreHiddenForCBS
    }), /*#__PURE__*/React.createElement(PostalPanel, {
      isFilterPopupOpen: isFilterPopupOpen,
      isSortingOpen: sortingIsOpen,
      onOpenFilterPanel: onOpenFilterPanel,
      onCloseFilterPanel: onCloseFilterPanel,
      onOpenSorting: this.openSorting
    }), /*#__PURE__*/React.createElement(CategoryDescription, {
      isFilterPopupOpen: isFilterPopupOpen,
      withAnimation: withAnimation
    }), /*#__PURE__*/React.createElement(Filters, {
      FilterItemComponent: FilterItem,
      productAttributes: productAttributes,
      productionTime: productionTime,
      minQuantity: minQuantity,
      colorFamily: colorFamily,
      categories: categories,
      onOpen: onOpenFilterPanel,
      onClose: onCloseFilterPanel,
      isOpen: isFilterPopupOpen,
      shouldShowBackLink: shouldShowBackLink,
      withAnimation: withAnimation,
      currentCategory: currentCategory,
      pricing: pricing,
      isLoading: isLoading,
      headerTitle: headerTitle,
      primaryColor: variables.primary,
      secondaryColor: variables.secondary,
      isCuratedBrandStore: isCuratedBrandStore,
      categoriesAndFiltersAreHiddenForCBS: categoriesAndFiltersAreHiddenForCBS
    }), /*#__PURE__*/React.createElement(MobileProductListingActiveFiltersRow, {
      isFilterPopupOpen: isFilterPopupOpen
    }), /*#__PURE__*/React.createElement(ProductsSorting, {
      sorting: sorting,
      anchorEl: anchorEl,
      isOpen: sortingIsOpen,
      anchorOrigin: anchorOrigin,
      targetOrigin: targetOrigin,
      openSorting: this.openSorting,
      closeSorting: this.closeSorting,
      sortProducts: this.sortProducts,
      primaryColor: variables.primary,
      secondaryColor: variables.secondary,
      isCuratedBrandStore: isCuratedBrandStore,
      categoriesAndFiltersAreHiddenForCBS: categoriesAndFiltersAreHiddenForCBS
    }), /*#__PURE__*/React.createElement(InfiniteProducts, {
      getProducts: getProducts,
      isFilterApplied: isActiveFilterBlockShown,
      currentCategoryName: currentCategoryName,
      isFilterPopupOpen: isFilterPopupOpen
    }), isAllProductsListPage && isProductsListFetched && /*#__PURE__*/React.createElement(HiddenPagination, null))) || null));
  }
}